import { ApiReportReportStatusChoices } from "@api/graphql/types-and-hooks";
import { useIsPeerReviewEnabled } from "@components/QaReview/hooks/useIsPeerReviewEnabled";
import { isReportAuthor } from "@components/ReportReview/hooks/useCanManageReview";
import { useCanReviewReport } from "@components/ReportReview/hooks/useCanReviewReport";
import { useMyAuth0Id } from "@components/ReportReview/hooks/useMyAuth0Id";
import { useReportReviewers } from "@components/ReportReview/hooks/useReportReviewers";
import { useReport } from "@providers/ReportProvider";

/**
 * An unsigned draft can be exported once Team Review has started, by its author and by anyone still asked to review
 * it. Admins who are neither get nothing. The API enforces the same rule.
 */
export const useCanExportDraft = (): boolean => {
  const { report } = useReport();
  const isPeerReviewEnabled = useIsPeerReviewEnabled();
  const { reviewers } = useReportReviewers();
  const myId = useMyAuth0Id();
  const myReview = useCanReviewReport();

  if (!isPeerReviewEnabled || report.reportStatus !== ApiReportReportStatusChoices.Draft) return false;
  return reviewers.length > 0 && (isReportAuthor(report, myId) || !!myReview);
};
